
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { propTypes, reduxForm, Field } from 'redux-form';
import { connect } from 'react-redux';
import compose from 'recompose/compose';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';




import { Card, CardActions } from 'material-ui/Card';
import Avatar from 'material-ui/Avatar';
import RaisedButton from 'material-ui/RaisedButton';
import TextField from 'material-ui/TextField';
import LockIcon from 'material-ui/svg-icons/action/lock-outline';
import { cyan500, pinkA200 } from 'material-ui/styles/colors';

import { Notification, translate, userLogin as userLoginAction,required,email } from 'admin-on-rest';


import { showNotification as showNotificationAction } from 'admin-on-rest';
import { push as pushAction } from 'react-router-redux';

const styles = {
    main: {
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        alignItems: 'center',
        justifyContent: 'center',
    },
    card: {
        minWidth: 300,
    },
    avatar: {
        margin: '1em',
        textAlign: 'center ',
    },
    form: {
        padding: '0 1em 1em 1em',
    },
    input: {
        display: 'flex',
    },
    hint: {
        textAlign: 'center',
        marginTop: '1em',
        color: '#ccc',
    },
};




// see http://redux-form.com/6.4.3/examples/material-ui/
const renderInput = ({ meta: { touched, error } = {}, input: { ...inputProps }, ...props }) =>
    <TextField
        errorText={touched && error}
        {...inputProps}
        {...props}
        fullWidth
    />;


class ChangePass extends Component {
   login = ({  password,newPassword,newPasswordAgain }) => {
           const { push,  showNotification } = this.props;
        
     //   userLogin({ username, password }, location.state ? location.state.nextPathname : '/');
const handleErrors=response=>{
if (!response.ok) {
        throw Error(response.statusText);
    }
    return response;
};
   const token = localStorage.getItem('token')
    

      const request = new Request('https://api-dev.slika.org.il/api/changepass', {
            method: 'POST',
            body: JSON.stringify({ password, newPassword,newPasswordAgain }),
            headers: new Headers({ 'Content-Type': 'application/json','Authorization':`Bearer ${token}` }),
        })
        
          return fetch(request)
         .then(response => response.text().then(text => ({
            status: response.status,
            statusText: response.statusText,
            headers: response.headers,
            body: text,
        })))
        .then(({ status, statusText, headers, body }) => {
            let json;
            try {
                json = JSON.parse(body);
            } catch (e) {
                // not json, no big deal
            }
            if (status < 200 || status >= 300) {
                //return Promise.reject(new HttpError((json && json.message) || statusText, status));
                showNotification(json.statusText, 'warning')
                return;
            }
             showNotification('Password Changed');
                push('/');
        });


          /*
          .then(function(object) {
            debugger;
  if (object.type === 'error') {
    console.log(object.type, object.message)
  } else {
    console.log('success')
  }
})
*/
 /*         .then(handleErrors )
            .then(response => {
                  showNotification('Password Changed');
                push('/');
            })
            .catch((e) => {
               
               console.error(e);
               showNotification(e.message, 'warning')
               
            });*/


     

    }

 

    render() {
        const { handleSubmit, submitting, theme, translate } = this.props;
        
        
        
        return (
           
                <div style={styles.main }>
                    <Card style={styles.card}>
                        <div style={styles.avatar}>
                            <Avatar  icon={<LockIcon />} size={60} />
                        </div>

                        <form onSubmit={handleSubmit(this.login)}>
                            <div style={styles.form}>
                                <p style={styles.hint}>איגוד הסליקה הישראלי</p>
                                <div style={styles.input} >
                                    <Field
                                        name="password"
                                        component={renderInput}
                                         type="password"
                                        floatingLabelText={translate('pass.password')}
                                        validate={[ required ]}
                                    />
                                </div>
                                <div style={styles.input}>
                                    <Field
                                        name="newPassword"
                                         
                                        component={renderInput}
                                        floatingLabelText={translate('pass.newPassword')}
                                        type="password"
                                         validate={[ required ]}
                                    />
                                </div>
                                  <div style={styles.input}>
                                    <Field
                                        name="newPasswordAgain"
                                         
                                        component={renderInput}
                                        floatingLabelText={translate('pass.newPasswordAgain')}
                                        type="password"
                                         validate={[ required ]}
                                    />
                                </div>
                            </div>
                            <CardActions>
                                <RaisedButton type="submit" primary disabled={submitting} label={translate('pass.changepass')} fullWidth />
                            </CardActions>
                        </form>
                    </Card>
                      <Notification />
                </div>
           
        );
    }
}
ChangePass.propTypes = {
    ...propTypes,
    authClient: PropTypes.func,
    previousRoute: PropTypes.string,
    theme: PropTypes.object.isRequired,
    translate: PropTypes.func.isRequired,
    push: PropTypes.func,
    
    showNotification: PropTypes.func,
};



ChangePass.defaultProps = {
    theme: {},
};

 
const enhance = compose(
    translate,
    reduxForm({
        form: 'signIn',
     
    }),
    connect(null, {       showNotification: showNotificationAction,
    push: pushAction,}),
);

export default enhance(ChangePass);



// WEBPACK FOOTER //
// ./src/changepass/ChangePass.js